<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >RPA流程清单</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item title="虚拟机" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.selectMac"
                                    :options="toolbar.macOptions"
                                    placeholder="全部"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="是否启用" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.isEnable"
                                    placeholder="全部"
                                    clearable
                                    style="width: 80px"
                                >
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="状态" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.State"
                                    placeholder="全部"
                                    clearable
                                    style="width: 80px"
                                >
                                    <vxe-option
                                        value="1"
                                        label="测试中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="运行中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="退役"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入业务人员姓名或邮箱,流程ID或名称"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button status="success" @click="addProcess"
                                    >新增</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        ref="xTable1"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="删除" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeProcessRowEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="编辑" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editProcessEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="RobotType"
                            title="类型"
                            width="80"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="流程ID"
                            width="140"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessNo"
                            title="流程名称"
                            width="250"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="JobName"
                            title="部门"
                            width="80"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="NAME"
                            title="业务人员"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="UserName"
                            title="邮箱"
                            width="180"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="DevelopUser"
                            title="开发人员"
                            width="140"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="Pc_No"
                            title="虚拟机"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="Abbr"
                            title="机器人简称"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="StateName"
                            title="状态"
                            width="80"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="Levele"
                            title="优先级"
                            width="90"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="CreationTime"
                            title="创建时间"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="DisplayName"
                            title="启用"
                            width="80"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="TimeOut"
                            title="超时时间"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ToMailAddress"
                            title="返回邮箱"
                            width="140"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="ToMobile"
                            title="返回手机"
                            width="140"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="DevPlatform"
                            title="开发平台"
                            width="100"
                            sortable
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <!-- 新增-->
            <vxe-modal
                v-model="formInput.isShow"
                @close="closeWinEvent"
                :title="formInput.title"
                width="840"
                height="520"
                ref="rForm"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formInput.formData"
                        :rules="formInput.formRules"
                        title-align="right"
                        ref="nForm"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="基本信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-address-card-o' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="流程名称"
                            field="ProcessNo"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.ProcessNo"
                                    placeholder="请输入流程名称"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    @click="selectPublish()"
                                    :disabled="formInput.allInputDisable"
                                    >选择</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="流程ID"
                            field="ProcessName"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.ProcessName"
                                    placeholder="请输入流程ID"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="虚拟机"
                            field="Pc_No"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.Pc_No"
                                    :options="toolbar.macOptions"
                                    placeholder="请选择虚拟机"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="业务人员"
                            field="UserEmail"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.UserEmail"
                                    readonly
                                    placeholder="请选择业务人员"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    @click="selectUser(1)"
                                    :disabled="formInput.allInputDisable"
                                    >选择</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="优先级"
                            field="Levele"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.Levele"
                                    placeholder="请选择优先级"
                                    clearable
                                >
                                    <vxe-option
                                        value="低"
                                        label="低"
                                    ></vxe-option>
                                    <vxe-option
                                        value="中"
                                        label="中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="高"
                                        label="高"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="数据来源"
                            field="DataSources"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.DataSources"
                                    placeholder="请选择数据来源"
                                    clearable
                                >
                                    <vxe-option
                                        value="文件"
                                        label="文件"
                                    ></vxe-option>
                                    <vxe-option
                                        value="附件"
                                        label="附件"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="开发人员"
                            field="DevelopUser"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.DevelopUser"
                                    placeholder="请输入开发人员姓名"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="机器类型"
                            field="RobotType"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.RobotType"
                                    placeholder="请选择机器类型"
                                    clearable
                                >
                                    <vxe-option
                                        value="有人值守"
                                        label="有人值守"
                                    ></vxe-option>
                                    <vxe-option
                                        value="无人值守"
                                        label="无人值守"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="是否启用"
                            field="Display"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.Display"
                                    placeholder="请选择是否启用"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                >
                                    <vxe-option
                                        value="1"
                                        label="启用"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="禁用"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="状态"
                            field="State"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.State"
                                    placeholder="请选择状态"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                >
                                    <vxe-option
                                        value="1"
                                        label="测试中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="运行中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="退役"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="秘钥加密"
                            field="IsEncrypt"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.IsEncrypt"
                                    placeholder="请选择秘钥加密"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                >
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="超时时间(分钟)"
                            field="TimeOut"
                            span="12"
                            title-width="140px"
                            :title-prefix="{
                                icon: 'fa fa-info-circle',
                                message:
                                    '本流程单次最大可执行时间，超过该时间后将会强制结束流程',
                            }"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.TimeOut"
                                    placeholder="请输入超时时候"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                    type="number"
                                    min="0"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            align="center"
                            span="24"
                            style="position: absolute; bottom: 0"
                        >
                            <template #default>
                                <vxe-button
                                    :disabled="formInput.saveButDisable"
                                    @click="saveNew"
                                    icon="fa fa-save"
                                    status="success"
                                    >保存
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <!-- 编辑-->
            <vxe-modal
                v-model="formEdit.isShow"
                @close="closeWinEvent"
                :title="formEdit.title"
                width="840"
                height="520"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formEdit.formData"
                        :rules="formEdit.formRules"
                        title-align="right"
                        ref="rFormEdit"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="基本信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-address-card-o' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="流程名称"
                            field="ProcessNo"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formEdit.formData.ProcessNo"
                                    placeholder="请输入流程名称"
                                    clearable
                                    :disabled="formEdit.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="流程ID"
                            field="ProcessName"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formEdit.formData.ProcessName"
                                    placeholder="请输入流程ID"
                                    clearable
                                    :disabled="formEdit.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="虚拟机"
                            field="Pc_No"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formEdit.formData.Pc_No"
                                    :options="toolbar.macOptions"
                                    placeholder="请选择虚拟机"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="业务人员"
                            field="UserEmail"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formEdit.formData.UserEmail"
                                    readonly
                                    placeholder="请选择业务人员"
                                    :disabled="formEdit.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    @click="selectUser(2)"
                                    :disabled="formEdit.allInputDisable"
                                    >选择</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="优先级"
                            field="Levele"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formEdit.formData.Levele"
                                    placeholder="请选择优先级"
                                    clearable
                                >
                                    <vxe-option
                                        value="低"
                                        label="低"
                                    ></vxe-option>
                                    <vxe-option
                                        value="中"
                                        label="中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="高"
                                        label="高"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="数据来源"
                            field="DataSources"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formEdit.formData.DataSources"
                                    placeholder="请选择数据来源"
                                    clearable
                                >
                                    <vxe-option
                                        value="文件"
                                        label="文件"
                                    ></vxe-option>
                                    <vxe-option
                                        value="附件"
                                        label="附件"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="开发人员"
                            field="DevelopUser"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formEdit.formData.DevelopUser"
                                    placeholder="请输入开发人员姓名"
                                    :disabled="formEdit.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="机器类型"
                            field="RobotType"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formEdit.formData.RobotType"
                                    placeholder="请选择机器类型"
                                    clearable
                                >
                                    <vxe-option
                                        value="有人值守"
                                        label="有人值守"
                                    ></vxe-option>
                                    <vxe-option
                                        value="无人值守"
                                        label="无人值守"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="是否启用"
                            field="Display"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formEdit.formData.Display"
                                    placeholder="请选择是否启用"
                                    clearable
                                    :disabled="true"
                                >
                                    <vxe-option
                                        value="1"
                                        label="启用"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="禁用"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="状态"
                            field="State"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formEdit.formData.State"
                                    placeholder="请选择状态"
                                    clearable
                                    :disabled="true"
                                >
                                    <vxe-option
                                        value="1"
                                        label="测试中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="运行中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="退役"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="秘钥加密"
                            field="IsEncrypt"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formEdit.formData.IsEncrypt"
                                    placeholder="请选择秘钥加密"
                                    clearable
                                    :disabled="formEdit.allInputDisable"
                                >
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="超时时间(分钟)"
                            field="TimeOut"
                            span="12"
                            title-width="140px"
                            :title-prefix="{
                                icon: 'fa fa-info-circle',
                                message:
                                    '本流程单次最大可执行时间，超过该时间后将会强制结束流程',
                            }"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formEdit.formData.TimeOut"
                                    placeholder="请输入超时时候"
                                    clearable
                                    :disabled="formEdit.allInputDisable"
                                    type="number"
                                    min="0"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="返回邮箱"
                            field="ToMailAddress"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formEdit.formData.ToMailAddress"
                                    placeholder="请输入返回邮箱"
                                    :disabled="formEdit.allInputDisable"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="返回手机"
                            field="ToMobile"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formEdit.formData.ToMobile"
                                    placeholder="请输入返回手机"
                                    :disabled="formInput.allInputDisable"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            align="center"
                            span="24"
                            style="position: absolute; bottom: 0"
                        >
                            <template #default>
                                <vxe-button
                                    :disabled="formEdit.saveButDisable"
                                    @click="save"
                                    icon="fa fa-save"
                                    status="success"
                                    >保存
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
                <template #default>
                    <div>
                        <vxe-form>
                            <vxe-form-item title="关键字" :item-render="{}">
                                <template #default>
                                    <vxe-input
                                        v-model="userTablePager.searchKey"
                                        placeholder="请输入姓名或邮箱"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        @click="findUserData"
                                        @keyup.enter="findUserData"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        status="primary"
                                        @click="confirmSelectUser"
                                        >确定</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="24">
                                <template #title>
                                    <span>已选(</span
                                    ><span style="color: red">双击选择</span
                                    ><span>)</span>
                                </template>
                                <template #default>
                                    <div v-if="userSelectType == 1">
                                        <template
                                            v-for="(item, index) in formInput
                                                .formData.UserNameEmail"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                            <va-icon
                                                class="icon-left input-icon"
                                                @click="clearUser(item.ID)"
                                                name="clear"
                                            />
                                        </template>
                                    </div>
                                    <div v-else>
                                        <template
                                            v-for="(item, index) in formEdit
                                                .formData.UserNameEmail"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                        </template>
                                    </div>
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="dtUser"
                            ref="xTableUser"
                            height="300"
                            @cell-dblclick="chooseUser"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Id"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="UserName"
                                title="姓名"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobZb"
                                title="总部"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobName"
                                title="部门"
                                width="120"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="UserMail"
                                title="邮箱"
                                width="200"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="uid"
                                title="uid"
                                width="10"
                                :visible="false"
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="userTablePager.currentPage"
                            v-model:page-size="userTablePager.pageSize"
                            :total="userTablePager.totalResult"
                            @page-change="handlePageChangeUser"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                title="选择发布流程"
                v-model="publishToolbar.isShow"
                width="700"
            >
                <template #default>
                    <div>
                        <vxe-form>
                            <vxe-form-item
                                title="关键字"
                                field="searchKey"
                                :item-render="{}"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="publishToolbar.searchKey"
                                        placeholder="请输入流程ID或流程名称"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        @click="findPublishData"
                                        @keyup.enter="findPublishData"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="publishToolbar.dtData"
                            ref="xTablePublish"
                            height="300"
                            @cell-dblclick="confirmSelectPublish"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Id"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="PubState"
                                title="发布阶段"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="ProcessID"
                                title="流程ID"
                                width="140"
                                resizable
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="ProcessName"
                                title="流程名称"
                                width="250"
                                show-overflow
                                resizable
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="UserName"
                                title="业务人员"
                                width="100"
                                show-overflow
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="DevelopUser"
                                title="开发人员"
                                width="140"
                                sortable
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="CoeTeacher"
                                title="COE导师"
                                width="100"
                                sortable
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="CreationTime"
                                title="申请时间"
                                width="140"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="AuditTime"
                                title="审批时间"
                                width="140"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="MachineName"
                                title="虚拟机"
                                width="140"
                                sortable
                            ></vxe-column>

                            <vxe-column
                                field="CreateMan"
                                title="创建人"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="CreateManEmail"
                                title="创建人邮箱"
                                width="180"
                                sortable
                                show-overflow
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="
                                publishToolbar.pager.currentPage
                            "
                            v-model:page-size="publishToolbar.pager.pageSize"
                            :total="publishToolbar.pager.totalResult"
                            @page-change="handlePageChangePublish"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                    <div style="width: 100%; float: right; text-align: right">
                        <vxe-button
                            status="primary"
                            @click="confirmSelectPublish"
                            >选择</vxe-button
                        >
                    </div>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive, ref } from "vue";
import { VXETable } from "vxe-table";

export default {
    name: "ProcessList",
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const userTablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            searchKey: "",
        });

        const toolbar = reactive({
            loading: false,
            macOptions: [],
            formData: {
                searchKey: "",
                selectMac: "",
                isEnable: "",
                State: "",
            },
        });

        const publishToolbar = reactive({
            loading: false,
            isShow: false,
            searchKey: "",
            dtData: [],
            pager: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
            },
        });

        const formInput = reactive({
            title: "新增流程",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            formData: {
                id: "",
                ProcessName: "",
                ProcessNo: "",
                Pc_No: "",
                UserName: "", //业务邮箱，返回后台保存值
                UserNameEmail: [], //显示中显示值
                UserEmail: "", //选择后的显示值
                Levele: "",
                DataSources: "文件",
                DevelopUser: "",
                RobotType: "",
                Display: "1",
                State: "",
                IsEncrypt: "",
                TimeOut: 0,
            },
            formRules: {
                ProcessNo: [{ required: true, message: "流程名称不能为空" }],
                ProcessName: [{ required: true, message: "流程ID不能为空" }],
                Pc_No: [{ required: true, message: "虚拟机不能为空" }],
                UserEmail: [{ required: true, message: "业务人员不能为空" }],
                UserName: [{ required: true, message: "业务人员不能为空" }],
                Levele: [{ required: true, message: "优先级不能为空" }],
                DataSources: [{ required: true, message: "数据来源不能为空" }],
                DevelopUser: [{ required: true, message: "开发人员不能为空" }],
                RobotType: [{ required: true, message: "机器类型不能为空" }],
                ToMailAddress: [
                    { required: false, message: "返回邮箱不能为空" },
                ],
                ToMobile: [{ required: false, message: "返回手机不能为空" }],
                Display: [{ required: true, message: "是否启用不能为空" }],
                State: [{ required: true, message: "状态不能为空" }],
                IsEncrypt: [{ required: true, message: "秘钥加密不能为空" }],
                TimeOut: [{ required: true, message: "超时时间不能为空" }],
            },
        });

        const formEdit = reactive({
            title: "编辑流程",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            formData: {
                id: "",
                ProcessName: "",
                ProcessNo: "",
                Pc_No: "",
                UserName: "", //选择后显示值
                UserEmail: "", //业务邮箱，返回后台保存值
                UserNameEmail: [], //选择中
                Levele: "",
                DataSources: "文件",
                DevelopUser: "",
                RobotType: "",
                ToMailAddress: "",
                ToMobile: "",
                Display: "1",
                State: "",
                IsEncrypt: "",
                TimeOut: 0,
            },
            formRules: {
                ProcessNo: [{ required: true, message: "流程名称不能为空" }],
                ProcessName: [{ required: true, message: "流程ID不能为空" }],
                Pc_No: [{ required: true, message: "虚拟机不能为空" }],
                UserEmail: [{ required: true, message: "业务人员不能为空" }],
                UserName: [{ required: true, message: "业务人员不能为空" }],
                Levele: [{ required: true, message: "优先级不能为空" }],
                DataSources: [{ required: true, message: "数据来源不能为空" }],
                DevelopUser: [{ required: true, message: "开发人员不能为空" }],
                RobotType: [{ required: true, message: "机器类型不能为空" }],
                ToMailAddress: [
                    { required: false, message: "返回邮箱不能为空" },
                ],
                ToMobile: [{ required: false, message: "返回手机不能为空" }],
                Display: [{ required: true, message: "是否启用不能为空" }],
                State: [{ required: true, message: "状态不能为空" }],
                IsEncrypt: [{ required: true, message: "秘钥加密不能为空" }],
                TimeOut: [{ required: true, message: "超时时间不能为空" }],
            },
        });

        return {
            tableData: null,
            tablePager,
            toolbar,
            formInput,
            dtUser: null,
            iShowSelectUser: ref(false),
            pageHeight,
            publishToolbar,
            userTablePager,
            formEdit,
            userSelectType: "1", //1 多选 2 单选
            tableHeight: 0,
        };
    },
    methods: {
        async removeProcessRowEvent(row) {
            const type = await VXETable.modal.confirm("您确定要删除该数据?");
            const $grid = this.$refs.xTable1;
            if (type === "confirm") {
                const param = {
                    id: row.id,
                };
                this.$api.publishManageAPI
                    .delProcess(Qs.stringify(param))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "删除成功",
                            status: "success",
                        });
                        $grid.remove(row);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //编辑
        editProcessEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: [row.id],
            };
            this.$api.publishManageAPI
                .getProcessOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formEdit.formData = res.data.Data;
                    this.formEdit.formData.UserNameEmail = [];
                    this.formEdit.formData.UserNameEmail.push({
                        Name: this.formEdit.formData.UserEmail,
                        ID: this.formEdit.formData.UserName,
                    });

                    this.formEdit.isShow = true;
                    this.formEdit.title = "编辑流程";
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        closeWinEvent() {
            this.findData();
        },
        async addProcess() {
            this.formInput.formData = {
                id: "",
                ProcessName: "",
                ProcessNo: "",
                Pc_No: "",
                UserName: "", //业务邮箱，返回后台保存值
                UserNameEmail: [], //显示中显示值
                UserEmail: "", //选择后显示
                Levele: "",
                DataSources: "文件",
                DevelopUser: "",
                RobotType: "",
                Display: "1",
                State: "",
                IsEncrypt: "",
                TimeOut: 0,
            };
            this.editType = "1"; //新增
            this.formInput.isShow = true;
            const $rForm = this.$refs.nForm;
            const re = await $rForm.clearValidate();
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    this.toolbar.formData.selectMac,
                    this.toolbar.formData.isEnable,
                    "",
                    "",
                    this.toolbar.formData.State,
                ],
            };
            this.$api.publishManageAPI
                .getProcessList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    //this.tableHeight = this.$calTableHeight(res.data.Data.dataTable.length);
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    ); // 调用全局函数
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindPC() {
            this.$api.systemManageAPI
                .getMachineList()
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.macOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.macOptions.push({
                            value: item.PcName,
                            label: item.Abbr,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        selectUser(type) {
            this.userSelectType = type;
            this.userTablePager.searchKey = "";
            this.findUserData();
            this.iShowSelectUser = true;
        },
        confirmSelectUser() {
            this.iShowSelectUser = false;
        },
        //删除用户
        clearUser(useremail) {
            let idx = -1;
            if (this.userSelectType == 1) {
                this.formInput.formData.UserNameEmail.forEach(function (
                    item,
                    index
                ) {
                    if (item.ID == useremail) {
                        idx = index;
                    }
                });
                let tmpId = [],
                    tmpname = [];
                tmpId = this.formInput.formData.UserEmail.toString().split(";");
                tmpname =
                    this.formInput.formData.UserName.toString().split(";");
                tmpId.splice(idx, 1);
                tmpname.splice(idx, 1);
                this.formInput.formData.UserEmail = tmpId.join(";"); //显示值
                this.formInput.formData.UserName = tmpname.join(";"); //邮箱
                let count = 0;
                if (this.formInput.formData.UserName.toString() != "") {
                    count =
                        this.formInput.formData.UserName.toString().split(
                            ";"
                        ).length;
                }
                this.formInput.formData.UserNameEmail = [];
                //debugger
                for (let i = 0; i < count; i++) {
                    this.formInput.formData.UserNameEmail.push({
                        Name: this.formInput.formData.UserEmail.toString().split(
                            ";"
                        )[i],
                        ID: this.formInput.formData.UserName.toString().split(
                            ";"
                        )[i],
                    });
                }
            } else {
                this.formEdit.formData.UserName = "";
                this.formEdit.formData.UserEmail = "";
                this.formEdit.formData.UserNameEmail = [];
            }
        },
        //选择用户
        chooseUser() {
            const $table = this.$refs.xTableUser;
            const record = $table.getCurrentRecord();
            if (record == null || record.length == 0) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }
            if (this.userSelectType == 1) {
                //新增时多选

                //判断是否已选择过
                if (this.formInput.formData.UserName.toString() != "") {
                    for (let item of this.formInput.formData.UserName.toString().split(
                        ";"
                    )) {
                        if (item == record.UserMail) {
                            VXETable.modal.message({
                                content: "该人员已选择",
                                status: "warning",
                            });
                            return;
                        }
                    }
                }

                if (
                    this.formInput.formData.UserEmail == null ||
                    this.formInput.formData.UserEmail.toString() == ""
                ) {
                    this.formInput.formData.UserEmail =
                        record.UserName + "(" + record.UserMail + ")";
                } else {
                    this.formInput.formData.UserEmail +=
                        ";" + record.UserName + "(" + record.UserMail + ")";
                }
                if (
                    this.formInput.formData.UserName == null ||
                    this.formInput.formData.UserName.toString() == ""
                ) {
                    this.formInput.formData.UserName = record.UserMail;
                } else {
                    this.formInput.formData.UserName += ";" + record.UserMail;
                }

                let count =
                    this.formInput.formData.UserName.toString().split(
                        ";"
                    ).length;
                this.formInput.formData.UserNameEmail = [];
                for (let i = 0; i < count; i++) {
                    this.formInput.formData.UserNameEmail.push({
                        Name: this.formInput.formData.UserEmail.toString().split(
                            ";"
                        )[i],
                        ID: this.formInput.formData.UserName.toString().split(
                            ";"
                        )[i],
                    });
                }
            } else {
                //编辑时单选

                this.formEdit.formData.UserEmail =
                    record.UserName + "(" + record.UserMail + ")";
                this.formEdit.formData.UserName = record.UserMail;
                this.formEdit.formData.ToMailAddress = record.UserMail;
                this.formEdit.formData.UserNameEmail = [];
                this.formEdit.formData.UserNameEmail.push({
                    Name: this.formEdit.formData.UserEmail.toString(),
                    ID: this.formEdit.formData.UserName.toString(),
                });
            }
        },
        //打开选择发布流程
        selectPublish() {
            this.publishToolbar.searchKey = "";
            this.findPublishData();
            this.publishToolbar.isShow = true;
        },
        handlePageChangePublish() {
            this.findPublishData();
        },
        //选择发布流程
        confirmSelectPublish() {
            const $table = this.$refs.xTablePublish;
            const record = $table.getCurrentRecord();
            if (record == null) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }

            this.$api.publishManageAPI
                .getProcessPublish(Qs.stringify({ publishId: record.Id }))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formInput.formData.ProcessName =
                        res.data.Data.ProcessName;
                    this.formInput.formData.ProcessNo = res.data.Data.ProcessNo;
                    this.formInput.formData.Pc_No = res.data.Data.Pc_No;
                    this.formInput.formData.Levele = res.data.Data.Levele;
                    this.formInput.formData.DevelopUser =
                        res.data.Data.DevelopUser;
                    this.formInput.formData.RobotType = res.data.Data.RobotType;
                    this.formInput.formData.State = res.data.Data.State;
                    this.formInput.formData.IsEncrypt = res.data.Data.IsEncrypt;

                    this.publishToolbar.isShow = false;
                })
                .catch((error) => {
                    VXETable.modal.message({ content: error, status: "error" });
                    console.log(error);
                });
        },
        //编辑保存流程
        async save() {
            const $rForm = this.$refs.rFormEdit;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }

            const params = this.formEdit.formData;

            if (this.formEdit.saveButDisable) {
                return;
            }
            this.$api.publishManageAPI
                .updateProcess(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "保存成功",
                        status: "success",
                    });

                    this.formEdit.isShow = false;
                    this.findData();
                })
                .catch((error) => {
                    VXETable.modal.message({ content: error, status: "error" });
                    console.log(error);
                });
        },
        //新增保存流程
        async saveNew() {
            const $rForm = this.$refs.nForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }
            const params = this.formInput.formData;

            if (this.formInput.saveButDisable) {
                return;
            }

            this.$api.publishManageAPI
                .addProcess(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "保存成功",
                        status: "success",
                    });
                    this.formInput.isShow = false;

                    this.findData();
                })
                .catch((error) => {
                    VXETable.modal.alert({ content: error, status: "error" });
                    console.log(error);
                });
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 202);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 26;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findUserData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.userTablePager.currentPage,
                pageSize: this.userTablePager.pageSize,
                searchKey: [this.userTablePager.searchKey, ""],
            };
            this.$api.systemManageAPI
                .getUserList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtUser = res.data.Data.dataTable;
                    this.userTablePager.currentPage = res.data.Data.currentPage;
                    this.userTablePager.pageSize = res.data.Data.pageSize;
                    this.userTablePager.totalResult = res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        findPublishData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.publishToolbar.pager.currentPage,
                pageSize: this.publishToolbar.pager.pageSize,
                searchKey: [this.publishToolbar.searchKey, "", "5"],
            };
            this.$api.publishManageAPI
                .getPublishList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.publishToolbar.dtData = res.data.Data.dataTable;
                    this.publishToolbar.pager.currentPage =
                        res.data.Data.currentPage;
                    this.publishToolbar.pager.pageSize = res.data.Data.pageSize;
                    this.publishToolbar.pager.totalResult =
                        res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        handlePageChangeUser() {
            this.findUserData();
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.isEnable = "";
            this.toolbar.formData.selectMac = "";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
    },
    mounted() {
        this.bindPC();
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}

th.vxe-header--column {
    height: 48px; /* 设置表头行高度 */
}
</style>
